"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_CLIENT_ID = exports.AUTH_DOMAIN = exports.AUTH_AUDIENCE = exports.APP_BASE_URL = exports.API_BASE_URL = void 0;
exports.API_BASE_URL = ((_a = globalThis.GLOBAL_TGCW_CONFIG) === null || _a === void 0 ? void 0 : _a.API_BASE_URL) ||
    process.env.TGCW_API_BASE_URL;
exports.APP_BASE_URL = ((_b = globalThis.GLOBAL_TGCW_CONFIG) === null || _b === void 0 ? void 0 : _b.APP_BASE_URL) ||
    process.env.TGCW_APP_BASE_URL;
exports.AUTH_AUDIENCE = ((_c = globalThis.GLOBAL_TGCW_CONFIG) === null || _c === void 0 ? void 0 : _c.AUTH_AUDIENCE) ||
    process.env.TGCW_AUTH_AUDIENCE;
exports.AUTH_DOMAIN = ((_d = globalThis.GLOBAL_TGCW_CONFIG) === null || _d === void 0 ? void 0 : _d.AUTH_DOMAIN) ||
    process.env.TGCW_AUTH_DOMAIN;
exports.AUTH_CLIENT_ID = ((_e = globalThis.GLOBAL_TGCW_CONFIG) === null || _e === void 0 ? void 0 : _e.AUTH_CLIENT_ID) ||
    process.env.TGCW_AUTH_CLIENT_ID;
